import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from '../context/AppContext';
import axios from 'axios';
import Swal from "sweetalert2";
import { useTranslation } from 'react-i18next';

function InstitutionalStatistics(){
    const navigate = useNavigate();
    const [secilenSutun,setSecilenSutun] = useState("0");
    const { userId,token, uniId } = useAppContext();
    const [aylikIstatistikVerisi, setAylikIstatistikVerisi] = useState([]);
    const [uyeler, setUyeler] = useState([]);
    const[sorgular, setSorgular] = useState([]);
    const [loading, setLoading] = useState(false);
    const [baslangicMetni, setBaslangicMetni] = useState("");

    function anaSayfayaDon(){
        navigate("/");
    }

    useEffect(()=>{
        setBaslangicMetni("Bir istatistik Seçiniz");
          
    },[])

    const dateParse = (e)=>{
        const yil = e.slice(0,4);
        const ay = e.slice(5,7);
        const gun = e.slice(8,10);
        const total = gun+"-"+ay+"-"+yil;
        console.log("Düzgün tarih: ",total);
        return total;
    }

    const aylikIstatistiklerGec = async() =>{
        setLoading(true);
        setSecilenSutun("1");
        setBaslangicMetni("");
        //${uniId}
        try{
            const response = await axios.get(`https://ai.kesifaraci.com/service/api/montly_report/university/${uniId}`,  {
                headers: {
                    Authorization: `Bearer ${token}`
                    
                }
            });
            setAylikIstatistikVerisi(response.data);
        }
        catch(error){
            console.log("hata:",error);
        }
        finally{
            setLoading(false);
        }
        
        
        
        }


    const sorgularGec= async()=>{
        setLoading(true);
        setSecilenSutun("2");
        setBaslangicMetni("");
        try{
            const response = await axios.get(`https://ai.kesifaraci.com/service/api/latest_question/university/${uniId}`,  {
                headers: {
                    Authorization: `Bearer ${token}`
                    
                }
            });
            setSorgular(response.data);
        }
        catch(error){
            console.log("hata:",error);
        }
        finally{
            setLoading(false);
        }
    }

    
    const allusers= async()=>{
        setLoading(true);
        setSecilenSutun("3");
        setBaslangicMetni("");
        try{
            const response = await axios.get(`https://ai.kesifaraci.com/service/api/allusers/university/${uniId}`,  {
                headers: {
                    Authorization: `Bearer ${token}`
                    
                }
            });
            setUyeler(response.data);
        }
        catch(error){
            console.log("hata:",error);
        }
        finally{
            setLoading(false);
        }
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={anaSayfayaDon}/>

            <div className="relative bg-white w-[90vw] max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg p-6 z-10">
                <button
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    onClick={anaSayfayaDon}
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                
                <div className="text-center mb-6">
                    <h2 className="text-2xl  font-semibold text-[#3c4f58]">Kurumsal İstatistikler</h2>
                    <div className="inline-flex rounded-md shadow-sm" role="group">
                        <button onClick={aylikIstatistiklerGec} type="button" className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                            İstatistikler (Aylık)
                        </button>
                        <button onClick={sorgularGec} type="button" className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                            Kullanıcı Sorgular
                        </button>
                        <button onClick={allusers} type="button" className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                            Kullanıcı Listesi
                        </button>

                    </div>
                    <h5>{baslangicMetni}</h5>
                </div>
                {loading && (
                    <div className="flex justify-center items-center h-screen">
                        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
                    </div>
                )}
                {
                !loading && secilenSutun === "1" && (
                    <div className="relative overflow-x-auto">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                    Universite Adı
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                    Yıl
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                    Ay
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                       Benzersiz Kullanıcı
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                       Kullanım Sayısı
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {aylikIstatistikVerisi.map((row, index) => (
                                    <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td className="px-6 py-4">{row.university_name}</td>
                                        <td className="px-6 py-4">{row.year}</td>
                                        <td className="px-6 py-4">{row.month}</td>
                                        <td className="px-6 py-4">{row.usage_count}</td>
                                        <td className="px-6 py-4">{row.unique_users}</td>
                                    </tr>
                                    
                                ))}
                                </tbody>
                        </table>
                    </div>
                )
                }

                {
                !loading && secilenSutun === "2" && (
                    <div className="relative overflow-x-auto">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3" colSpan="2">
                                    Soru
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {sorgular.map((row, index) => (
                                    <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td colSpan="2" className="px-6 py-4">{row.question}</td>
                                    </tr>
                                ))}
                                </tbody>
                        </table>
                    </div>
                    )
                }
                {
                !loading && secilenSutun === "3" && (
                    <div className="relative overflow-x-auto">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3" colSpan="2">
                                    Kullanıcılar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {uyeler.map((row, index) => (
                                    <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                        <td className="px-6 py-4">{row.isim_soyisim}</td>
                                        <td className="px-6 py-4">{row.email}</td>
                                    </tr>
                                ))}
                                </tbody>
                        </table>
                    </div>
                    )
                }
                

            </div>
        </div>
    )
}

export default InstitutionalStatistics;